import { useEffect } from 'react';
import flow from 'lodash/fp/flow';
import keys from 'lodash/fp/keys';
import head from 'lodash/fp/head';
import map from 'lodash/fp/map';
import filter from 'lodash/fp/filter';
import get from 'lodash/fp/get';

const getFirstKey = flow(keys, head);

export default function useScrollToFirstError({ fields, errors = {}, submitCount }) {
	const isValid = Object.keys(errors).length === 0;

	// if we have fields use that to determine the first error by looping through and seeing if there is an error for each otherwise just use the first key from errors
	const firstFieldWithError = fields
		? flow(
				map(get('name')),
				filter(name => get(name)(errors)),
				head
			)(fields)
		: null;

	const elementId = firstFieldWithError || getFirstKey(errors);

	useEffect(() => {
		if (isValid) return;

		const element = document.getElementById(elementId);

		if (!element) return;

		// Scroll to first known error into view
		element.scrollIntoView({ behavior: 'smooth', block: 'center' });
	}, [elementId, isValid, submitCount]);
}
